<template>
  <section id="home">
    <div class="row">
      <div class="col-lg-5">
        <div class="home-info">
          <div class="logo">
            <img :src="messages.home?.logo ?? null"/>
          </div>
          <div class="content">
            <span class="title">{{ messages.home.title }}</span>
            {{ messages.home.content }}
          </div>
          <div class="info">
            <a class="btn-smartville" target="_blank">
              {{ messages.home.download_app.text }}
            </a>
          </div>
          <div class="info">
            <div class="row">
              <div class="col-md-6">
                <a href="https://play.google.com/store/apps/details?id=gr.ianic.smartville" target="_blank">
                  <img class="android" v-bind:src="require('./../assets/img/android.svg')" alt="Smartville Android App" height="180">
                </a>
                <a href="https://apps.apple.com/gr/app/smartville/id1596791470" target="_blank">
                  <img class="ios" v-bind:src="require('./../assets/img/ios.svg')" alt="Smartville IOS App" height="180">
                </a>
              </div>
              <div class="col-md-6">
                <img class="qr" v-bind:src="require('./../assets/img/qr.svg')" alt="Smartville Mobile QR code" height="180">
              </div>
            </div>
          </div>
          <div class="info">
            <a class="btn-smartville" v-bind:href="messages.home.smartville_my.href" target="_blank">
              {{ messages.home.smartville_my.text }}
            </a>
          </div>
        </div>
      </div>
      <div class="col-lg-7">
        <ul class="menu-home">
          <li v-for="(item,index) in messages.menu" class="app" :key="index">
            <a v-bind:href="item.href" target="_blank">
              {{ item.text }}
            </a>
          </li>
        </ul>
        <div class="home-video" v-bind:style="'background-image: url('+require('./../assets/img/bg-home.webp')+')'">
          <div class="video" data-toggle="modal" v-bind:style="'background-image: url('+require('./../assets/img/video.webp')+')'" v-on:click="open()">

          </div>
        </div>
      </div>
    </div>
  </section>
  <modal_video ref="modal"></modal_video>
</template>

<script>
import modal_video from '../components/modal.vue';
export default {
  name: "home_component",
  components:{
    modal_video
  },
  data(){
    return {
      messages:{}
    };
  },
  methods:{
    open(){
      this.$refs.modal.open_modal(this.messages.home.youtube)
    },
  },
  beforeMount() {
    this.messages = window.messages;
  }
}
</script>

<style scoped>

</style>